"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputWrapper = exports.InputField = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const InputField = exports.InputField = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "styles__InputField",
  componentId: "components-web__sc-1lrz1xk-0"
})(["order:1;text-align:center;z-index:10;input{text-align:center;}"]);
const InputWrapper = exports.InputWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "styles__InputWrapper",
  componentId: "components-web__sc-1lrz1xk-1"
})(["text-align:start;display:flex;flex-direction:row;flex-wrap:nowrap;"]);